import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';
import { Mapper } from '@Features/utils/prepareSearchCriterias';

import { FilterForm } from './types';

export const initialValues: FilterForm = {
  workShift: [],
  dateFrom: '',
  dateTo: '',
  statuses: [],
  resumingFrom: '',
  currentLocation: '',
};

export const filterTypes: Record<
  keyof typeof initialValues,
  SearchItemOperator
> = {
  workShift: 'in',
  dateFrom: 'ge',
  dateTo: 'le',
  statuses: 'in',
  resumingFrom: 'eq',
  currentLocation: 'like',
};

export const getFiltersMapper =
  (statuses: TypeDict[], workShifts: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['startDate', value];
    }

    if (key === 'dateTo') {
      return ['startDate', value];
    }

    if (key === 'workShift') {
      const workShiftCodes = (value as string[]).map(
        (item) =>
          workShifts.find((workShift) => workShift.codeDesc === item)!.codeNum
      );
      return ['ticketRequired', workShiftCodes];
    }

    if (key === 'resumingFrom') {
      return ['leaveTypeID', Number(value)];
    }

    if (key === 'currentLocation') {
      return ['currentLocation', value];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };
